import React, { useEffect, useState } from 'react';
import './Tabbing.css';

const Tabbing = ({
    titleOne = '',
    titleTwo = '',
    description = '',
    ingredients = '',
    onTabChange,
    defaultTab = '',
    wrapperClassName = '',
}) => {
    const [activeTab, setActiveTab] = useState(defaultTab || titleOne);

    useEffect(() => {
        if (onTabChange) {
            onTabChange(activeTab);
        }
    }, []);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (onTabChange) onTabChange(tab);
    };

    return (
        <div className={`description-ingredients-container ${wrapperClassName}`}>
            <div className="tab-container">
                <div className={`slider ${activeTab === titleTwo ? 'right' : 'left'}`} />

                <button
                    className={`tab-button ${activeTab === titleOne ? 'active' : ''}`}
                    onClick={() => handleTabClick(titleOne)}
                >
                    {titleOne}
                </button>
                <button
                    className={`tab-button ${activeTab === titleTwo ? 'active' : ''}`}
                    onClick={() => handleTabClick(titleTwo)}
                >
                    {titleTwo}
                </button>
            </div>

            {!onTabChange && (
                <div className='tab-content'>
                    {activeTab === titleOne && (
                        <div
                            className='tabbing-description'
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}
                    {activeTab === titleTwo && (
                        <p dangerouslySetInnerHTML={{ __html: ingredients }} />
                    )}
                </div>
            )}
        </div>

    );
};

export default Tabbing;
